const BlogCatalog = () => import("@/views/modules/beauty/BlogCatalog.vue");
const SingleBlog = () => import("@/views/modules/beauty/SingleBlog.vue");
const VideoCatalog = () => import("@/views/modules/beauty/VideoCatalog2.vue");
const SingleVideo = () => import("@/views/modules/beauty/SingleVideo.vue");
const FavoritesVideo = () =>
  import("@/views/modules/beauty/FavoritesVideo.vue");
const BeautyPlanner = () => import("@/views/modules/beauty/BeautyPlanner.vue");

const subdomainsPortal = [
  import.meta.env.VITE_MAIN_SUBDOMAIN,
  import.meta.env.VITE_TEST_SUBDOMAIN,
];

export default [
  {
    path: "/blog/catalog",
    name: "blog-catalog",
    component: BlogCatalog,
    meta: { allowedSubdomains: subdomainsPortal, hideForPortalTypeBooks: true },
  },
  {
    path: "/blog/:id",
    name: "single-blog",
    component: SingleBlog,
    meta: {
      requiresAuth: true,
      allowedSubdomains: subdomainsPortal,
      hideForPortalTypeBooks: true,
    },
  },
  {
    path: "/video/catalog",
    name: "video-catalog",
    component: VideoCatalog,
    meta: { allowedSubdomains: subdomainsPortal, hideForPortalTypeBooks: true },
  },
  {
    path: "/video/:id",
    name: "single-video",
    component: SingleVideo,
    meta: {
      requiresAuth: true,
      allowedSubdomains: subdomainsPortal,
      hideForPortalTypeBooks: true,
    },
  },
  {
    path: "/my-profile/favorites",
    name: "favorites-video",
    component: FavoritesVideo,
    meta: {
      requiresAuth: true,
      allowedSubdomains: subdomainsPortal,
      hideForPortalTypeBooks: true,
    },
  },
  {
    path: "/planner",
    name: "beauty-planner",
    component: BeautyPlanner,
    meta: { allowedSubdomains: subdomainsPortal, hideForPortalTypeBooks: true },
  },
];
